import React from "react";
import ReportsSearchBar from "../components/reports/ReportsSearchBar";
import ReportsTable from "../components/reports/ReportsTable";
import Layout from "../components/layout/Layout";

const ReportsPage = () => {
  return (
    <Layout>
      <div className="pt-16 ml-64">
        <ReportsSearchBar />
        <div className="flex flex-col mt-4">
          <ReportsTable />
        </div>
      </div>
    </Layout>
  );
};

export default ReportsPage;
